import axios from "axios";
import Config from "../../../config/index";
import { CREATE_REPAIR_VALUE_FAILURE, CREATE_REPAIR_VALUE_REQUEST, CREATE_REPAIR_VALUE_SUCCESS, EDIT_PREPAIR_FAILURE, EDIT_PREPAIR_REQUEST, EDIT_PREPAIR_SUCCESS, GET_DELETE_REPAIR_VALUE_FAILURE, GET_DELETE_REPAIR_VALUE_REQUEST, GET_DELETE_REPAIR_VALUE_SUCCESS, GET_REPAIR_VALUE_FAILURE, GET_REPAIR_VALUE_REQUEST, GET_REPAIR_VALUE_SUCCESS, UPLOAD_PREPAIR_FAILURE, UPLOAD_PREPAIR_REQUEST, UPLOAD_PREPAIR_SUCCESS } from "./repairValueTypes";


let baseUrl = Config.baseUrl;
let baseUrlFileUploadTemp = Config.baseUrlFileUploadTemp;

const getRepairValueRequest = () => {
  return {
    type: GET_REPAIR_VALUE_REQUEST,
  };
};

const getRepairValueSuccess = (payload) => {
  return {
    type: GET_REPAIR_VALUE_SUCCESS,
    payload: payload,
  };
};

const getRepairValueFailure = (error) => {
  return {
    type: GET_REPAIR_VALUE_FAILURE,
    payload: error,
  };
};
const getRepairValue = (dppId, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };

  return (dispatch) => {
    dispatch(getRepairValueRequest());

    let url;

    if (dppId) {
      // When dppId is provided
      url = `${baseUrl}/dpp/repair_recycle_value/get_dpp?dppId=${dppId}`;
    } else {
      // Default call when dppId is not provided
      url = `${baseUrl}/dpp/repair_recycle_value/get_all`;
    }

    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getRepairValueSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getRepairValueFailure(err.message));
      });
  };
};




const deleteRepairValueRequest = () => {
  return {
    type: GET_DELETE_REPAIR_VALUE_REQUEST,
  };
};

const deleteRepairValueSuccess = (payload) => {
  return {
    type: GET_DELETE_REPAIR_VALUE_SUCCESS,
    payload: payload,
  };
};

const deleteRepairValueFaliure = (error) => {
  return {
    type: GET_DELETE_REPAIR_VALUE_FAILURE,
    payload: error,
  };
};

const deleteRepairValue = (dppId, udBy,jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(deleteRepairValueRequest());
    let url = `${baseUrl}/dpp/repair_recycle_value/delete?rrvId=${dppId}&udBy=${udBy}`;
    // let url = `${baseUrl}/dpp/product_passport/delete?dppId=${dppId}`;
    // let url = `${baseUrl}/mvtmap?id=${productId}`;
    // let url = `/mvtmap?id=334`;
    return axios
      .delete(url, {}, headers)
      .then((response) => {
        dispatch(deleteRepairValueSuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(deleteRepairValueFaliure(err.response));
        return { status: false, data: err.response };
      });
  };
};


const createRepairValueRequest = () => {
  return {
    type: CREATE_REPAIR_VALUE_REQUEST,
  };
};

const createRepairValueSuccess = (payload) => {
  return {
    type: CREATE_REPAIR_VALUE_SUCCESS,
    payload: payload,
  };
};

const createRepairValueFailure = (error) => {
  return {
    type: CREATE_REPAIR_VALUE_FAILURE,
    payload: error,
  };
};

const createRepairValue = (payload, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(createRepairValueRequest());
    let url = `${baseUrl}/dpp/repair_recycle_value/create`;
    return axios
      .post(url, payload, headers)
      .then((response) => {
        dispatch(createRepairValueSuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(createRepairValueFailure(err.response));
        return { status: false, data: err.response };
      });
  };
};


const editRepairRequest = () => {
  return {
    type: EDIT_PREPAIR_REQUEST,
  };
};

const editRepairSuccess = (payload) => {
  return {
    type: EDIT_PREPAIR_SUCCESS,
    payload: payload,
  };
};

const editRepairFailure = (error) => {
  return {
    type: EDIT_PREPAIR_FAILURE,
    payload: error,
  };
};

const editRepair = (payload, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(editRepairRequest());
    let url = `${baseUrl}/dpp/repair_recycle_value/update`;
    return axios
      .put(url, payload, headers)
      .then((response) => {
        dispatch(editRepairSuccess(response));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(editRepairFailure(err.response));
        return { status: false, data: err.response };
      });
  };
};



const uploadForRepairValueRequest = () => {
  return {
    type: UPLOAD_PREPAIR_REQUEST,
  };
};

const uploadForRepairValueSuccess = (payload) => {
  return {
    type: UPLOAD_PREPAIR_SUCCESS,
    payload: payload,
  };
};

const uploadForRepairValueFailure = (error) => {
  return {
    type: UPLOAD_PREPAIR_FAILURE,
    payload: error,
  };
};

const uploadForRepairValue = (payload, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(uploadForRepairValueRequest());
    let url = `${baseUrlFileUploadTemp}/dpp_repair_value/upload`;
    return axios
      .post(url, payload, headers)
      .then((response) => {
        dispatch(uploadForRepairValueSuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(uploadForRepairValueFailure(err.response));
        return { status: false, data: err.response };
      });
  };
};


export {
  getRepairValue,
  deleteRepairValue,
  createRepairValue,
  editRepair,
  uploadForRepairValue
  //  getDocumentTypeWithPagination
  //  , createDocumentType
};
